module.exports = __webpack_public_path__ + "img/Avatar3.63b2045e.png";